module.exports = __webpack_public_path__ + "img/arrow-go-back-line-active.c23cfc62.svg";